import axios from "axios";
const { API_BACKEND_HOST } = process.env;
const responseFormat = { error: "", data: null };

export const getAllDeliberations = async (params) => {
  const languageId = localStorage.getItem("i18nextLng");

  try {
    const { data } = await axios.post(
      `${API_BACKEND_HOST}${languageId}/v1/FinalDeliberations/filters`,
      params
    );

    responseFormat.data = data;
    responseFormat.error = "";

    return responseFormat;
  } catch ({ response }) {
    responseFormat.error = "async";

    return responseFormat;
  }
};

export const getBySlotId = async (slotId) => {
  const languageId = localStorage.getItem("i18nextLng");

  try {
    const { data } = await axios.get(
      `${API_BACKEND_HOST}${languageId}/v1/FinalDeliberations/${slotId}`
    );

    responseFormat.data = data;
    responseFormat.error = "";

    return responseFormat;
  } catch ({ response }) {
    responseFormat.error = "async";

    return responseFormat;
  }
};

export const sendExtract = async (formData) => {
  const languageId = localStorage.getItem("i18nextLng");

  try {
    const { data } = await axios.post(
      `${API_BACKEND_HOST}${languageId}/v1/FinalDeliberations/SendExtractDeliberation`,
      formData,
    );

    responseFormat.data = data;
    responseFormat.error = "";

    return responseFormat;
  } catch ({ response }) {
    responseFormat.error = response.data.errors.length > 0 ? response.data.errors.join(', ') : "";

    return responseFormat;
  }
};
